import { render, staticRenderFns } from "./AssetsOverYN.vue?vue&type=template&id=62c33a4a"
import script from "./AssetsOverYN.vue?vue&type=script&lang=js"
export * from "./AssetsOverYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports